import PropTypes from 'prop-types';
import React from 'react';
import styles from './Modal.scss';

export default class ModalContent extends React.Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    return (
      <div className={`${styles.mobileModalContent}`}>
        <div className={`row ${styles.mobileModalBody}`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/MobileModal/Content.js